<template>
  <vs-row>
    <vs-col vs-lg="6">
      <vs-row>
        <vs-col
          vs-xs="12"
          vs-sm="12"
          vs-md="3"
          vs-lg="3"
          class="px-2"
          v-for="(card, idx) in data.filter((el, i) => i < 4)"
          :key="idx"
        >
          <statistics-card
            class="mb-base w-full"
            :icon="card.icon"
            :title="card.label"
            :statistic="card.total"
            :color="card.color"
            :id="card.id"
            :style="{ cursor: 'pointer' }"
            :active="card.active"
            @click="changeFilter(card.id)"
          />
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="6">
      <vs-row>
        <vs-col
          vs-xs="12"
          vs-sm="12"
          vs-md="3"
          vs-lg="3"
          class="px-2"
          v-for="(card, idx) in data.filter((el, i) => i >= 4)"
          :key="idx"
        >
          <statistics-card
            class="mb-base w-full"
            :icon="card.icon"
            :title="card.label"
            :statistic="card.total"
            :color="card.color"
            :id="card.id"
            :style="{ cursor: 'pointer' }"
            :active="card.active"
            @click="changeFilter(card.id)"
          />
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import StatisticsCard from '@/views/expenses/components/StatisticsCard.vue'
export default {
  components: {
    StatisticsCard,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods:{
      changeFilter(status){
          this.$emit('updateFilter',status)
      }
  }
}
</script>

<style>
</style>